import { Box, Grid, Typography, Link } from '@mui/material';
import React, { useState } from 'react';

const RegistrationSuccessScreen = () => {

  return (
    <>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ marginTop: '50px', }}
      >
        <Grid item xs={3} >
          <Box sx={{ textAlign: 'center', marginTop: '30px', }}>
            <img src='/logo_b.png' style={{ display: 'inline' }} />
          </Box>
          <Typography variant='h5'
            sx={{
              color: '#603813',
              textTransform: 'uppercase',
              fontWeight: '600',
              fontSize: '18px',
              textAlign: 'center',
              marginTop: '22px',
            }}>
            Welcome!
          </Typography>

          <Grid
            container
            spacing={1}
            sx={{
              justifyContent: "center"
            }}
          >

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ textAlign: 'center', marginTop: '20px' }}>
              <Typography>Enjoy Shopping</Typography>
            </Grid>


          </Grid>


        </Grid>

      </Grid>

    </>
  )
}

export default RegistrationSuccessScreen;